import { h } from 'preact';
import classNames from 'classnames';

import { links } from '../../constants';

type Props = {
    className?: string;
    author?: string;
    quote?: string;
};

export const Quote = ({ className, quote, author }: Props) => (
    <blockquote className={classNames('c-quote', className)}>
        <p className="c-quote__quote">{quote}</p>
        {author && (
            <footer className="c-quote__footer">
                <span className="c-quote__cite">{author}</span>,{' '}
                <a href={links.HUGO_TRUSTPILOT} target="_blank" rel="noreferrer noopener">
                    Trustpilot
                </a>
            </footer>
        )}
    </blockquote>
);
